export default __webpack_public_path__ + "media/src/features/open-house-registration-hdp/assets/chevron-a00184f152abf0781372f832c4d03d13.svg";